export var Key;
(function (Key) {
  Key["SpaceBar"] = "";
  Key["PageUp"] = "PageUp";
  Key["PageDown"] = "PageDown";
  Key["End"] = "End";
  Key["Home"] = "Home";
  Key["Left"] = "ArrowLeft";
  Key["Up"] = "ArrowUp";
  Key["Right"] = "ArrowRight";
  Key["Down"] = "ArrowDown";
})(Key || (Key = {}));